import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/**
 * Temporary alias: /customer/* → /enduser/*
 * Keeps old bookmarks working after the persona/path rename.
 */
const CustomerToEnduserRedirect = () => {
  const location = useLocation();
  const to = {
    pathname: location.pathname.replace(/^\/customer(?=\/|$)/, '/enduser'),
    search: location.search,
    hash: location.hash,
  };
  return <Navigate to={to} replace />;
};

export default CustomerToEnduserRedirect;
